import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetProcessAccessSettingsQuery = (uid?: string) => {
  return useQuery({
    queryKey: ['getProcessAccessSettings', uid],
    queryFn: () => Api.orders.getProcessAccessSettings(uid || ''),
    enabled: !!uid,
  });
};
